import React from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Button } from '@/components/ui/button';
import { toast } from '@/components/ui/use-toast';
import { ExternalLink, Loader2 } from 'lucide-react';

const ConnectFormAssemblyButton: React.FC = () => {
  const [isLoading, setIsLoading] = React.useState(false);

  const handleConnect = async () => {
    setIsLoading(true);
    try {
      const { data, error } = await supabase.functions.invoke('formassembly-oauth-initiate');

      if (error) {
        toast({
          variant: "destructive",
          title: "Connection Error",
          description: `Could not initiate FormAssembly connection: ${error.message}`,
        });
        setIsLoading(false);
        return;
      }

      if (data && data.authorizationUrl) {
        if (data.state) {
          sessionStorage.setItem('fa_oauth_state', data.state);
        }
        window.location.href = data.authorizationUrl;
      } else {
        toast({
          variant: "destructive",
          title: "Connection Error",
          description: data.error || "Could not get authorization URL from server. Please try again.",
        });
        setIsLoading(false);
      }
    } catch (e) {
      const errorMessage = e instanceof Error ? e.message : "An unexpected error occurred.";
      toast({
        variant: "destructive",
        title: "Connection Error",
        description: errorMessage,
      });
      setIsLoading(false);
    }
  };

  return (
    <Button onClick={handleConnect} disabled={isLoading}>
      {isLoading ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          Connecting...
        </>
      ) : (
        <>
          Connect Form Provider
          <ExternalLink className="ml-2 h-4 w-4" />
        </>
      )}
    </Button>
  );
};

export default ConnectFormAssemblyButton;
